import lodash from 'lodash'
import React, { useEffect, useMemo } from 'react'

import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  FieldPrefix,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../1stlog-ui/src/components/Field/useFieldState'
import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'
import { usePrevious } from '../../../../../1stlog-ui/src/hooks'
import AddressPickerAdvanced from '../../../AddressPickerAdvanced'
import Contact from '../../../AddressPickerAdvanced/Contact'
import ContactExpander from '../../../AddressPickerAdvanced/ContactExpander'
import AddressPickerAdvancedReadonly from '../../../AddressPickerAdvanced/Readonly'
import AddressSwitch from '../../components/AddressSwitch'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { useProductSettings } from '../../Products'
import useOrderEntry from '../../useOrderEntry'
import { getAddressPickerLabels } from '../../utils/getAddressPickerLabels'
import { useCustoms } from '../Customs'
import { OwnDeliveryAddress } from './OwnDeliveryAddress'
import { useIsPhoneRequired } from './useIsPhoneRequired'

interface TDeliveryAddressProps
  extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  readonly?: boolean
}

const DeliveryAddress = (props: TDeliveryAddressProps): React.ReactElement => {
  const { readonly, ...rest } = props

  const { preset, currentCustomer } = useOrderEntry()

  // const { returnAddresses = [] } = currentCustomer ?? {}

  const { allowDeliveryAddressEdit, isDeliveryAddressStatic } = preset

  const { isCrossingEu } = useCustoms()

  const country = useField('address.country')

  const addresses = useField('addresses')

  const [isEdit, setIsEdit] = useField('isEdit', { asState: true })

  const {
    eoriIsNeverMandatory,
    isPrenameSurnameContactVisible,
    isDeliveryPhoneAlwaysRequired,
    receiverContactNameRequired,
  } = useProductSettings()

  // const { isPrenameSurnameContactVisible } = useDeliveryProduct() || {}

  const isPhoneRequiredGlobal = useIsPhoneRequired()
  const isPhoneRequired = isDeliveryPhoneAlwaysRequired || isPhoneRequiredGlobal

  // useEffect(() => {
  //   if (!isDeliveryAddressStatic) {
  //     setTimeout(() => setIsEdit(true), 0)
  //   }
  // }, [isDeliveryAddressStatic])

  // // only for internal use, no customer = open form
  // useEffect(() => {
  //   if (!currentCustomer) {
  //     setIsEdit(true)
  //   }
  // }, [currentCustomer])

  const showIsEdit = useMemo(
    () =>
      (allowDeliveryAddressEdit && isDeliveryAddressStatic) || !currentCustomer,
    [allowDeliveryAddressEdit, isDeliveryAddressStatic, currentCustomer],
  )

  const isEoriRequired = !eoriIsNeverMandatory && isCrossingEu

  const [isOwnDeliveryAddress, setIsOwnDeliveryAddress] =
    useFieldState<boolean>('isOwnDeliveryAddress')
  const showContact = useField('address.showContact')

  // Pickup address not editing anymore
  const isPickupAddressEdit = useFieldValue('pickup.isEdit', {
    ignorePrefix: true,
  })
  const previousIsPickupAddressEdit = usePrevious(isPickupAddressEdit)
  useEffect(() => {
    if (previousIsPickupAddressEdit && !isPickupAddressEdit) {
      setIsOwnDeliveryAddress(false)
    }
  }, [isPickupAddressEdit])

  return (
    <>
      {/* <ReadonlyAddressCache /> */}
      <OrderEntryCard
        {...rest}
        title={i18n.t('delivery_address', 'Zustelladresse')}
      >
        <OwnDeliveryAddress readonly={readonly} />
        {/* <>
          <pre>
            {JSON.stringify(
              {
                allowDeliveryAddressEdit,
                isDeliveryAddressStatic,
                isEdit,
                showIsEdit,
              },
              null,
              2,
            )}
          </pre>
        </> */}
        {!readonly && showIsEdit && !isOwnDeliveryAddress && (
          <Field name="isEdit">
            <Checkbox
              label={i18n.t(
                'different_delivery_address',
                'Abweichende Zustelladresse',
              )}
            />
          </Field>
        )}
        {!readonly &&
          !isEdit &&
          lodash.size(addresses) > 0 &&
          !isOwnDeliveryAddress && <AddressSwitch addresses={addresses} />}
        <FieldPrefix prefix="address">
          {isEdit && !readonly && !isOwnDeliveryAddress ? (
            <AddressPickerAdvanced
              isEoriRequired={isEoriRequired}
              hidePrenameSurname={
                isPrenameSurnameContactVisible === false &&
                !receiverContactNameRequired
              }
              isPhoneRequired={isPhoneRequired}
              showEori
              labels={getAddressPickerLabels()}
              isNameRequired={receiverContactNameRequired}
            />
          ) : (
            <AddressPickerAdvancedReadonly />
          )}
          {isOwnDeliveryAddress && !readonly && (
            <>
              <div className="mt-2">
                <Field name="showContact">
                  <Checkbox>
                    {i18n.t('showContact', 'Kontaktdaten einblenden')}
                  </Checkbox>
                </Field>
              </div>
              <ContactExpander alwaysOpen={receiverContactNameRequired} />
              <div hidden={!showContact}>
                <Contact
                  isEoriRequired={isEoriRequired}
                  showEori
                  isPhoneRequired={isPhoneRequired}
                  hidePrenameSurname={isPrenameSurnameContactVisible === false}
                  isNameRequired={receiverContactNameRequired}
                />
              </div>
            </>
          )}
        </FieldPrefix>
      </OrderEntryCard>
    </>
  )
}

export default DeliveryAddress
